// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_AU_","cls2":"LoggedOutDiscoveryPage-cls2_0_D LoggedOutDiscoveryPage-cls1_AU_"};